import { useCallback, useEffect, useRef, useState } from "react";
import { useApi } from "./useApi";
import {priceResponce} from "../types/price";

/**
 * 旅行代金確認
 *
 * ★`retry` を返す（issue #2992 / 2026-09-07）。
 *   `/price` はホテル→航空→アクティビティ→オプション→レンタカーを**逐次**呼ぶため、
 *   混雑時は 120 秒のタイムアウトに達しやすい。失敗したときに画面へ留めて
 *   同じ条件で引き直せるようにする（プランページへ戻すと検索がやり直しになり、
 *   1人あたり約20回の上流コールが再発生する）。
 * ★`retryAfterSec` はサーバー指示（サーキットブレーカの遮断残り時間）。
 *
 * @returns
 */
export const useTravelPrice = (input: {data: any}) => {

  const [isLoading, setLoading] = useState(false);

  const [error, setError] = useState<string|null>(null);

  let isError = error !== null;

  const [retryAfterSec, setRetryAfterSec] = useState<number | undefined>(undefined);

  // note: レスポンスが固まったら型を指定したい・・
  const [priceData, setPriceData] = useState<priceResponce>();

  // ★再取得のときは**その時点の条件**で引き直す（初回の依存配列に固定されないようにする）
  const inputRef = useRef(input);
  inputRef.current = input;

  const fetchData = useCallback(async () => {
    setLoading(true);
    setError(null);
    setRetryAfterSec(undefined);

    try {
      const response = await useApi.post({
        url: "/price",
        data: inputRef.current.data
      });

      const priceData = response.data as priceResponce;

      if (priceData.status === 200) {
        setPriceData(priceData);
      } else {
        setError("料金の取得に失敗しました。");
        setRetryAfterSec((priceData as {retryAfterSec?: number})?.retryAfterSec);
        isError = true;
      }

    } catch (error) {
      setError("APIの呼び出しに失敗しました。");
      setRetryAfterSec(
          (error as {response?: {data?: {retryAfterSec?: number}}})?.response?.data?.retryAfterSec);
      isError = true;
    }

    setLoading(false);

    return;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return [ priceData, { isLoading, isError, error, retryAfterSec, retry: fetchData } ] as const;
};